/**
 * The empty-photo illustration.
 *
 * A tiny storefront rather than a crossed-out image glyph: the space is
 * standing in for a picture of a place, so drawing the place says the same
 * thing without the "error" connotation a struck-through icon carries.
 *
 * Same 1.5px stroke grid as the skyline, `currentColor` throughout, so it
 * inherits whatever muted tone the card gives it.
 */
export function NoPhoto({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 64 40"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      focusable="false"
    >
      {/* awning */}
      <path d="M14 14h36l-4-6H18l-4 6Z" />
      <path d="M14 14h36" />
      <path d="M21 14v2M28 14v2M35 14v2M42 14v2" />

      {/* facade */}
      <path d="M17 34V14M47 34V14" />
      <path d="M11 34h42" strokeOpacity="0.5" />

      {/* door, slightly ajar */}
      <path d="M22 34V22h8v12" />
      <path d="M28 28h.01" />

      {/* window with a table in it */}
      <path d="M35 22h8v7h-8z" />
      <path d="M39 29v3M37 32h4" strokeOpacity="0.6" />
    </svg>
  )
}
